import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Renderer2,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { finalize, fromEvent, map, switchMap, takeLast, takeUntil, tap } from 'rxjs';

import { mouseRxUtils } from '@blaze-shared/shared-util';

const MIN_COLUMN_WIDTH_PX = 10;
const RESIZING_CLASS = 'resizing';

@UntilDestroy()
@Component({
  selector: 'be-resize-drawer',
  template: '',
  styleUrls: ['./resize-drawer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ResizeDrawerComponent implements AfterViewInit {
  private readonly renderer = inject(Renderer2);
  private readonly el = inject(ElementRef);

  private drawer?: HTMLElement;
  element: HTMLElement;

  constructor() {
    this.element = this.el.nativeElement;
  }

  ngAfterViewInit(): void {
    this.drawer = this.element.parentElement?.parentElement as HTMLElement;
    fromEvent<MouseEvent>(this.element, 'mousedown')
      .pipe(
        tap((event) => {
          event.preventDefault();
          this.renderer.addClass(this.element, RESIZING_CLASS);
        }),
        map((event) => ({
          startX: event.pageX,
          columnWidth: this.drawer?.offsetWidth ?? MIN_COLUMN_WIDTH_PX,
        })),
        switchMap((config) =>
          fromEvent<MouseEvent>(document, 'mousemove').pipe(
            map((moveEvent) => {
              let width = config.columnWidth - (moveEvent.pageX - config.startX);
              if (width < MIN_COLUMN_WIDTH_PX) {
                width = MIN_COLUMN_WIDTH_PX;
              }
              if (this.drawer) {
                this.drawer.style.width = `${width}px`;
              }
              return width;
            }),
            takeUntil(mouseRxUtils.buttonRelease()),
            takeLast(1),
            finalize(() => {
              this.renderer.removeClass(this.element, RESIZING_CLASS);
            }),
          ),
        ),
        untilDestroyed(this),
      )
      .subscribe();
  }
}
